import React, { Component } from "react";
import { accessRole } from "../../../../../helpers/access_role";
import Shimmer from "react-shimmer-effect";
import apiResponse from "../../../../../services/apiResponse";
import DataTableBloc from "./Blocs/DataTableBloc";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import moment from "moment";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
} from "reactstrap";

import TableActiveComponent from "./Components/TablePrimaryComponent";

class IndexView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirm: false,
      success: false,
      loading: false,
      failed: false,
      lastSync: null,
    };
    this.dataTableBloc = new DataTableBloc();
    this.activeRef = React.createRef();
  }

  reloadActiveRef = () => this.activeRef.current.setTokenAPI();

  confirmResponse = (response) => {
    switch (response) {
      case "cancel":
        this.setState({ confirm: false });
        break;
      case "confirm":
        this.dataTableBloc.fetchSyncData();
        this.setState({ loading: true, confirm: false });
        break;
      case "success":
        this.setState({ success: false });
        break;
      case "failed":
        this.setState({ failed: false });
        break;
      default:
    }
  };

  componentDidMount() {
    this.dataTableBloc.syncDataChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ loading: false, success: true });
          this.reloadActiveRef();
          break;
        case apiResponse.ERROR:
          this.setState({ loading: false, failed: true });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.syncDataChannel?.unsubscribe();
  }

  render() {
    const { confirm, success, loading, failed, lastSync } = this.state;

    return (
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>
                <div className="float-end">
                  <Button
                    color="primary"
                    onClick={() => this.setState({ confirm: true })}
                  >
                    Sinkronisasi Jabatan Fungsional Umum
                  </Button>
                </div>
                <CardTitle>Daftar Jabatan Fungsional Umum</CardTitle>
                <CardSubtitle className="mb-3">
                    Terakhir sinkronisasi: <b>{ lastSync || <Shimmer><div style={{width: 150, height: 10}} /></Shimmer>}</b>
                </CardSubtitle>
                <hr />
                <TableActiveComponent ref={this.activeRef} setLastSync={(lastSync)=> this.setState({lastSync:lastSync})}  />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan melakukan sinkronisasi?"
          loadingTitle="Melakukan sinkronisasi data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disinkronisasi"
          failedTitle="Gagal!"
          failedInfo="Data gagal disinkronisasi"
          showConfirm={confirm}
          showLoading={loading}
          showSuccess={success}
          showFailed={failed}
          response={this.confirmResponse}
        />
      </Container>
    );
  }
}

export default IndexView;
